import useMyProfileStore from "@/hooks/useMyProfileStore";
import useVisitOtherProfileStore from "@/hooks/useVisitOtherProfileStore";
import { Button, Card } from "antd";
import { useMemo } from "react";
import { HiPencil } from "react-icons/hi";

const ProfileFavoritesWidget = ({ isVisiting }: { isVisiting: boolean }) => {
  const { userView, setState } = useMyProfileStore();
  const { user } = useVisitOtherProfileStore();

  const convertSelectedFave = useMemo(() => {
    const userSource = isVisiting ? user : userView;

    if (userSource?.user?.selectedFavorites) {
      return userSource?.user?.selectedFavorites.map((key: any) => ({
        label: `${key
          .replaceAll("fave", "Favorite_")
          .replaceAll(/([a-z])([A-Z])/g, "$1 $2")
          .split("_")
          .join(" ")}`,
        value: userSource?.user?.favorites?.[key as never],
      }));
    }
    return [];
  }, [
    userView?.user?.selectedFavorites,
    user?.user?.selectedFavorites,
    isVisiting,
  ]);

  return (
    <Card
      title={
        <div className="flex w-full items-center justify-between">
          <h3 className="font-bold text-lg text-white m-0">
            {isVisiting ? "" : "My "}Favorites
          </h3>
          {!isVisiting && (
            <Button
              type="text"
              icon={<HiPencil />}
              onClick={() => setState({ isEditFavoritesModalOpen: true })}
            />
          )}
        </div>
      }
    >
      <div className="flex flex-col gap-2">
        {convertSelectedFave.length === 0 ? (
          <>{ isVisiting ? "Highlighting one's favorites helps to earns points." : "Earn points by highlighting your favorites here!" }</>
        ) : (
          convertSelectedFave.map((item: any) => (
            <div key={item?.value}>
              <p className="text-neutral-200 ">{item?.label}</p>
              <h3 className="font-semibold text-xl text-white mb-4">
                {item?.value}
              </h3>
            </div>
          ))
        )}
      </div>
    </Card>
  );
};

export default ProfileFavoritesWidget;
